import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { Container, Content } from '../styles/SharedBlockStyledComponents';

const Colors = {
  dark: `var(--color-primary)`,
  light: `var(--color-bg)`,
};

const ContentMaxWidth = '800px';
const ContentPadding = '15px  1rem';

const UnderlinedLink = styled(Link)`
  text-decoration: underline;
  font-weight: 400;

  &:hover {
    text-decoration: underline;
  }
`;

const ImageHolder = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 41%; /* makes it thinner */
  background: linear-gradient(
    180deg,
    var(--grey-2) 0,
    var(--grey-2) 50%,
    var(--primary) 50%,
    var(--primary) 100%
  );
  overflow: hidden;
  border-radius: 50px;

  img {
    position: absolute;
    object-fit: cover;
  }
`;

export default function BlockOurStoryHardcoded() {
  return (
    <div>
      <Container className="relative mt-16">
        <Content
          className="our-story"
          $maxWidth={ContentMaxWidth}
          $padding={ContentPadding}
        >
          OUR STORY
        </Content>
      </Container>
      <Container className="relative mb-4">
        <Content
          className="our-story"
          $maxWidth={ContentMaxWidth}
          $padding={ContentPadding}
        >
          <h2 className="h2">
            People say on-demand routing is complicated. We&nbsp;know how right
            they are.
          </h2>
        </Content>
      </Container>
      <Container>
        <Content
          className="our-story"
          $maxWidth={ContentMaxWidth}
          $padding={ContentPadding}
        >
          <p>
            Managing on-demand fleets involves juggling a lot of moving parts.
            That’s&nbsp;true. But to anyone who’s tried to do it, it’s also a
            laughable understatement.
          </p>
          <p className="mt-6">Every moving part behaves unpredictably.</p>
          <p>Changing conditions make estimates meaningless.</p>
          <p>Closest isn’t always fastest, and fastest isn’t always optimal.</p>
          <p className="mt-6">
            You’re not just solving for multiple variables at once.
          </p>
          <p>You’re solving for how each affects the others, too.</p>
        </Content>
      </Container>
      <Container
        $bgColor={Colors.dark}
        $textColor={Colors.light}
        style={{ padding: '2rem 0', marginTop: '9px' }}
      >
        <Content
          className="our-story"
          $maxWidth={ContentMaxWidth}
          $padding={ContentPadding}
        >
          <p>
            Getting on-demand and logistics routing right, at scale, means adapting
            constantly.
          </p>
          <p>
            That kind of real-time, coordinated reactivity requires one heck of
            an algorithm.
          </p>
          <p className="mt-6">We ought to know; we built it.</p>
        </Content>
      </Container>
      <Container style={{ backgroundColor: 'var(--color-bg)' }}>
        <Content
          className="our-story"
          $maxWidth={ContentMaxWidth}
          $padding={ContentPadding}
        >
          <p className="mt-6">
            We started from the ground up with a founding team of rideshare
            veterans, transit experts, and the algorithmic engineers who wrote {' '}
            <UnderlinedLink to="https://www.pnas.org/doi/10.1073/pnas.1611675114">
              the most cited scientific research on the topic globally
            </UnderlinedLink>
            .
          </p>
          <p className="mt-6">
            7 years and more than{' '}
            <UnderlinedLink to="/resources">5 million rides</UnderlinedLink>{' '}
            later, we’re proud to say{' '}
            <UnderlinedLink to="/algorithm">
              our road-tested technology
            </UnderlinedLink>{' '}
            powers the most efficient on-demand fleets on the planet.
          </p>
          <p className="mt-6">And we have miles and miles to go.</p>
          <Link to="/contact" className="btn--rounded bg--secondary mt-6">
            Contact us to learn more
          </Link>
          <ImageHolder className="mt-12">
            <StaticImage src="../images/about-hero.png" alt="Our Story" />
          </ImageHolder>
        </Content>
      </Container>
    </div>
  );
}
